<template>
      <v-chip class="userInfo" color="primary">
        <v-avatar>
          <v-icon large>mdi-account-circle</v-icon>
        </v-avatar>
        <span class="font-weight-bold pl-3">
          <span class="d-none d-sm-inline">{{ $t('lbl.user') }}: </span>
          {{this.findUserAttributesByKey('name')}} ( {{this.getUser().User.Username}} )
        </span>
      </v-chip>
</template>

<script>
export default {
  methods: 
	{	
    findUserAttributesByKey(key)
    {
      if(!this.isEmptyObj(this.getUser()) && !this.isEmptyObj(this.getUser().User) && !this.isEmptyObj(this.getUser().User.UserAttributes))
      {
        for (var i = 0; i < this.getUser().User.UserAttributes.length; i++) 
        {
          var userAttribObj = this.getUser().User.UserAttributes[i];	
          if(userAttribObj.Name== key)
          {
            return userAttribObj.Value;
          }
        }
        return '';
      }
      else 
      {
         return '';
      }
    } 
  }  
}
</script>